import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import CreateTask from './create-task.vue';
import PopulationStatistics from './components/population-statistics.vue';
import QueueList from './components/queue-table.vue';
import OffDutyDetection from './components/off-duty-detection.vue';
import { getAllTaskList } from '@blade-sxp/task-management/api/statistics/index';
import DeviceCascader from '@blade-sxp/task-management/components/device-cascader.vue';
import authItem from '@blade/common/components/auth/auth-item.vue';
import commomList from '@blade-sxp/task-management/pages/create-task/components/common-table.vue';
import { getTaskList } from '@blade-sxp/task-management/api/off-duty-detection/index';
import { listCard, typePath } from '@blade-sxp/task-management/config/tableConfig';
import { LoginModule } from '@blade/common/store/login';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import datePicker from '@blade/common/components/date-time-select/index.vue';
let TaskList = class TaskList extends Vue {
    permissions = [];
    permissionlevel = permissionlevel;
    taskCode = '';
    form = {
        keyword: '',
        dateRange: [],
        deviceIdList: [],
    };
    dateRange = ['', ''];
    taskStatus = '';
    zoneId = '';
    deviceIdList = [];
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    pageOrderList = [
        {
            orderField: 'create_time',
            orderType: 'DESC',
        },
    ];
    data = [];
    devices = [];
    activeTab = '';
    activeTask = '';
    dialogVisible = false;
    copyValue = '';
    loading = false;
    taskList = [];
    listCard = [];
    defaultTime = ['00:00:00', '23:59:59'];
    onConditionUpdate(form) {
        this.pagination.page = 1;
        this.getTaskList();
    }
    get isListCardData() {
        return this.listCard && this.listCard.length > 0;
    }
    created() {
        this.initPermissions();
        this.initTabs();
        this.initActiveTab();
        this.initActiveTask();
    }
    mounted() {
        this.getTaskList();
    }
    initActiveTab() {
        this.listCard = this.listCard.filter((card) => !this.isTabDisabled(card.key));
        this.activeTab = this.listCard?.[0]?.key;
    }
    clickNewTask() {
        this.taskTypeToPath('add');
    }
    isTabDisabled(key) {
        let isAble = false;
        const currentObject = this.listCard?.find((item) => item.key === key);
        if (currentObject) {
            isAble = currentObject.cardList && currentObject.cardList?.length > 0;
        }
        return !isAble;
    }
    initActiveTask() {
        if (this.listCard) {
            const { cardList } = this.listCard[0] || {};
            this.activeTask = cardList[0].key;
            this.taskCode = cardList[0].code;
        }
    }
    initTabs() {
        this.listCard = this.filterPermissionByTabs(listCard);
    }
    filterPermissionByTab(pms, code) {
        const permissions = this.permissions.filter((permission) => permission?.code === code)?.[0]?.subPermissions ?? [];
        const targetCards = pms.filter((card) => permissions.some((permission) => permission?.code === card.code && permission?.enable));
        return targetCards;
    }
    filterPermissionByTabs(pms) {
        const targetCards = pms.filter((card) => this.permissions.some((permission) => permission?.code === card.code && permission?.enable));
        targetCards.forEach((item) => {
            item.cardList = this.filterPermissionByTab(item.cardList, item.code);
        });
        return targetCards;
    }
    initPermissions() {
        this.permissions =
            (LoginModule?.permissions ?? []).filter((permission) => permission?.code === '03')?.[0]?.subPermissions ?? [];
    }
    getTaskList() {
        this.data = [];
        this.loading = true;
        if (!this.form.dateRange || this.form.dateRange?.length === 0) {
            this.dateRange = ['', ''];
        }
        else {
            this.dateRange = this.form.dateRange;
        }
        const reqParam = {
            taskTypes: [this.activeTask],
            page: this.pagination.page,
            size: this.pagination.size,
            dateEnd: this.dateRange[1],
            dateStart: this.dateRange[0],
            pageOrderList: this.pageOrderList,
            deviceIds: this.form.deviceIdList,
            keyword: this.form.keyword,
            zoneId: this.zoneId,
            taskStatus: this.taskStatus,
        };
        getTaskList({ ...reqParam })
            .then((res) => {
            if (res?.list?.length > 0) {
                this.data = res.list ?? [];
            }
            else {
                this.data = [];
                if (res.totalPage > 1) {
                    this.pagination.page = res.totalPage;
                    this.$set(this.pagination, 'page', res.totalPage);
                    this.getTaskList();
                }
            }
            this.pagination.total = res.total;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    activated() {
        this.pagination.page = 1;
        this.getTaskList();
    }
    refresh() {
        this.getTaskList();
    }
    changeParam(type, value) {
        switch (type) {
            case 'size':
                this.pagination.size = Number(value);
                break;
            case 'current':
                this.pagination.page = Number(value);
                break;
            case 'zoneId':
                this.pagination.page = 1;
                this.zoneId = String(value);
                break;
            case 'taskStatus':
                this.pagination.page = 1;
                this.taskStatus = String(value);
                break;
            case 'sort':
                this.pageOrderList[0].orderType = String(value);
                break;
        }
        this.getTaskList();
    }
    handleClick() {
        if (this.activeTab && this.listCard) {
            const currentObject = this.listCard?.find((item) => item.key === this.activeTab);
            if (currentObject) {
                this.activeTask = currentObject.cardList[0].key;
                this.taskCode = currentObject.cardList[0].code;
            }
        }
        this.pagination.page = 1;
        this.zoneId = '';
        this.taskStatus = '';
        this.pageOrderList[0].orderType = 'DESC';
        this.getTaskList();
    }
    newTask(command) {
        if (command === 'new') {
            this.taskTypeToPath('add');
        }
        else {
            this.dialogVisible = true;
            this.loading = true;
            this.getAllTaskList();
        }
    }
    goPage(id, type) {
        this.taskTypeToPath(type, id);
    }
    taskTypeToPath(type, id) {
        const taskType = this.activeTask;
        let path = '';
        if (taskType) {
            path = typePath[taskType];
            let query = id ? { type: type, taskType, id: String(id) } : { type: type, taskType };
            this.$router.push({ path, query: query });
        }
    }
    handleReset() {
        this.form = {
            keyword: '',
            dateRange: [],
            deviceIdList: [],
        };
    }
    getAllTaskList() {
        const data = {
            taskTypes: [this.activeTask],
        };
        getAllTaskList(data)
            .then((resp) => {
            this.taskList = resp;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    crowdTabChange(item) {
        this.activeTask = item.key;
        this.taskCode = item.code;
        this.pagination.page = 1;
        this.zoneId = '';
        this.taskStatus = '';
        this.pageOrderList[0].orderType = 'DESC';
        this.getTaskList();
    }
    closeDialog() {
        this.dialogVisible = false;
        this.copyValue = '';
    }
    confirmDialog() {
        this.dialogVisible = false;
        const id = this.copyValue;
        this.taskTypeToPath('copy', id);
        this.copyValue = '';
    }
};
__decorate([
    Watch('form', { deep: true, immediate: false })
], TaskList.prototype, "onConditionUpdate", null);
TaskList = __decorate([
    Component({
        name: 'TaskList',
        components: {
            CreateTask,
            commomList,
            PopulationStatistics,
            QueueList,
            OffDutyDetection,
            'device-cascader': DeviceCascader,
            authItem,
            AuthNewitem,
            datePicker,
        },
        i18n: {
            messages: {
                en: {
                    inputHolder: 'Task Name/Creator ',
                    start: 'Start date',
                    end: 'End date',
                    week: 'Last week',
                    halfMonth: 'Last 15 days',
                    crowd: 'Crowd and Individual',
                    face: 'Face',
                    human: 'Body',
                    vehicl: 'Vehicle',
                    faceRatio: 'Face Comparison',
                    faceRecognition: 'Face Attribute Recognition',
                    faceCombination: 'Face&Body Recognition',
                    humanRecognition: 'Body Attribute Recognition',
                    vehicleRecognition: 'Vehicle Attribute Recognition',
                    queue: 'Queue Management',
                    crowdCount: 'Crowd Counting',
                    staffLeave: 'Unauthorized Leave',
                    newTask: 'New Task',
                    copyTask: 'Copy Task',
                    reset: 'Reset',
                    task: 'Task',
                    choose: 'Select',
                    device: 'Device',
                    crowdDetention: 'Crowd Retention',
                    crowdCountercurrent: 'Crowd Counterflow',
                    crowdInvasion: 'Crowd Intrusion',
                    socialDistance: 'Close Social Distance',
                    crowdGatheredAndDispersed: 'Crowd Gather and Dispersion',
                    crowdDensity: 'Crowd Density',
                    road: 'Road',
                    pavementDefects: 'Pavement Defects',
                    waste: 'Waste',
                    wasteDetection: 'Waste Detection',
                    kitchen: 'Kitchen',
                    KitchenConduct: 'Anomaly',
                    crowdCrossline: 'Crowd Counting (Crossline)',
                    behavior: 'Behavior',
                    abnormalBehavior: 'Abnormal Behavior',
                    fireDetection: 'Fire Detection',
                    traffic: 'Traffic',
                    crowdCrosslineVirtual: 'Crowd Counting (Virtual)',
                    counterflowDriving: 'Counterflow Driving',
                    motorVehicle: 'Non-motor Vehicle and Pedestrian Intrusion',
                    congestion: 'Congestion',
                    crossline: 'Crowd Crossline',
                    humanRecognitionCrossline: 'Body Attribute Recognition (Crossline)',
                    unidentifiedObject: 'Unidentified Object Retention Detection',
                    unidentified: 'Object',
                    nonMotorVehicle: 'Non-motor Vehicle',
                    nonMotorVehicleAttribute: 'Non-motor Vehicle Attribute Recognition',
                    largeModel: 'Larget Model',
                    alalysisEverything: 'Analysis of Everything',
                },
                zh: {
                    inputHolder: '请输入任务名称/创建人',
                    start: '开始',
                    end: '结束',
                    week: '近一周',
                    halfMonth: '近15天',
                    crowd: '人群任务',
                    face: '人脸任务',
                    human: '人体任务',
                    vehicl: '车辆任务',
                    queue: '排队管理',
                    faceRatio: '人脸比对',
                    faceRecognition: '人脸属性识别',
                    faceCombination: '人脸&人体联合',
                    humanRecognition: '人体属性识别',
                    vehicleRecognition: '车辆属性识别',
                    crowdCount: '人群统计',
                    staffLeave: '人员离岗',
                    newTask: '创建任务',
                    copyTask: '复制任务',
                    reset: '重置',
                    task: '任务',
                    choose: '请选择',
                    device: '设备',
                    crowdDetention: '人群滞留',
                    crowdCountercurrent: '人群逆流',
                    crowdInvasion: '人群入侵',
                    socialDistance: '社交距离',
                    crowdGatheredAndDispersed: '人群聚集分散',
                    crowdDensity: '人群密度',
                    road: '道路任务',
                    pavementDefects: '路面缺陷',
                    waste: '垃圾检测',
                    wasteDetection: '垃圾检测 ',
                    kitchen: '餐厅检测',
                    KitchenConduct: '厨房行为规范',
                    crowdCrossline: '人群统计(跨线)',
                    crossline: '人群跨线',
                    behavior: '行为检测',
                    abnormalBehavior: '异常行为检测',
                    fireDetection: '烟火检测',
                    traffic: '交通事件',
                    crowdCrosslineVirtual: '人群计数（虚拟区域）',
                    counterflowDriving: '逆行',
                    illegalParking: '违停',
                    motorVehicle: '非机动车和行人入侵',
                    congestion: '拥堵',
                    humanRecognitionCrossline: '人体属性识别（跨线）',
                    unidentifiedObject: '不明物体滞留检测',
                    unidentified: '物品检测',
                    nonMotorVehicle: '非机动车任务',
                    nonMotorVehicleAttribute: '非机动车属性识别',
                    largeModel: '大模型',
                    alalysisEverything: '万物解析',
                },
            },
        },
    })
], TaskList);
export default TaskList;
